import { PHONE_1, PHONE_1_DISPLAY } from '../../../components/feature/TopBar';

const WA_LINK = `https://wa.me/90${PHONE_1}?text=${encodeURIComponent('Merhaba, profesyonel temizlik hizmeti için randevu almak istiyorum.')}`;

export default function StickyMobileBar() {
  const handleScroll = () => {
    const el = document.querySelector('#appointment');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 shadow-[0_-2px_20px_rgba(0,0,0,0.08)]">
      <div className="flex items-stretch">
        {/* Call */}
        <a
          href={`tel:${PHONE_1}`}
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 hover:bg-gray-50 transition-colors border-r border-gray-100"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-phone-fill text-emerald-500 text-xl" />
          </span>
          <span className="text-[10px] font-semibold text-gray-600 whitespace-nowrap">Ara</span>
        </a>

        {/* WhatsApp */}
        <a
          href={WA_LINK}
          target="_blank"
          rel="nofollow noreferrer"
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 hover:bg-gray-50 transition-colors border-r border-gray-100"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-whatsapp-line text-[#25D366] text-xl" />
          </span>
          <span className="text-[10px] font-semibold text-gray-600 whitespace-nowrap">WhatsApp</span>
        </a>

        {/* Appointment */}
        <button
          onClick={handleScroll}
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 bg-emerald-500 hover:bg-emerald-600 transition-colors cursor-pointer"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-calendar-check-line text-white text-xl" />
          </span>
          <span className="text-[10px] font-semibold text-white whitespace-nowrap">Randevu Al</span>
        </button>
      </div>
    </div>
  );
}
